module.exports = __webpack_public_path__ + "media/images/back-cover-2b6cde80f7c3501ec333c0cb6d36be23.svg";